import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Database_overview extends PureComponent {
  render() {
    return (
      <div className="row" id="database_overview">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Database Overview</h2>
              <p>
                To achieve the speed and performance, Nexoid uses a NoSQL
                database. For those of you who are new to NoSQL databases think
                of them as a collection of JSON or XML files in a folder. Each
                file is a record, and the folder is the table (confusingly
                sometimes referred to as an index). The advantage of this is you
                can store n-dimensional data as opposed to a traditional SQL
                database which only allows for two-dimensions. NoSQL allows
                maximum flexibility with the ability to change data schemas on
                the fly. Comparing NoSQL to traditional SQL solutions, we have
                performance increases typically in the range of 250 times
                faster.
              </p>
              <p>
                NoSQL records are designed to be self-containing and do not
                support foreign key constraints. We have found in most examples
                this is not an issue due to the n-dimensional nature of a JSON
                record; however, in the event, a use case requires a
                self-correcting parent-child relationship the workflow webhooks
                function can be used to create a self-correcting record.
              </p>
              <p>
                Behind the scenes, the Nexoid platform uses an ElasticSearch
                database with a REST API wrapper. The REST API adds a simple,
                secure wrapper handling all permissions, auditing and webhook
                workflows. This documentation covers a high-level overview of
                how queries work. For more detail, you can also look at the
                Elastic Search documentation.
              </p>
              <p>Individual records are limited to 14MB. </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol">
          <div className="contentDark"></div>
        </div>
      </div>
    );
  }
}

export default Database_overview;



// WEBPACK FOOTER //
// ./src/components/knowlege/overview/Database_overview.js